import React from 'react';
import Logo from './Logo';
import NavbarToggler from './NavbarToggler';
import UserMenu from './UserMenu';
import DarkModeToggle from './DarkModeToggle';
import NotificationDropdown from './NotificationDropdown';
import NavLinks from './NavLinks';

const Navbar = () => {
  return (
    <aside className="navbar navbar-vertical navbar-expand-lg" data-bs-theme="dark">
      <div className="container-fluid">
        <NavbarToggler />
        <Logo />
        <div className="navbar-nav flex-row d-lg-none">
          <div className="d-none d-lg-flex">
            <DarkModeToggle />
            <NotificationDropdown />
          </div>
          {/* <UserMenu /> */}
        </div>
        <div className="collapse navbar-collapse" id="sidebar-menu">
          <NavLinks />
        </div>
      </div>
    </aside>
  );
};

export default Navbar; 